import React from 'react';
import PropTypes from 'prop-types';
import './ProjectBrief.css';
import loader from './loader.gif';

export const ProjectBrief = ({
  projectName,
  projectBrief,
  projectPicture,
  projectAttachments,
  handleProjectBriefInput,
  handleProjectUpload,
  handleRemoveUpload,
  isUploadingAttachment,
  isUploadingProjectPicture,
}) => (
  <div className="project-brief-card">
    <div className="new-account__content-element">
      <div className="new-account__content-input-label form-label">
        Project Name
      </div>
      <input
        type="text"
        name="project_name"
        placeholder="Name of my project"
        onChange={handleProjectBriefInput}
        defaultValue={projectName}
        className="new-account__content-input"
      />
    </div>

    <div className="new-account__content-element">
      <div className="new-account__content-input-label form-label">
        Creative Brief
      </div>
      <textarea
        type="text"
        name="project_brief"
        placeholder="Description of my brief"
        rows="4"
        onChange={handleProjectBriefInput}
        defaultValue={projectBrief}
        className="project-brief-card__textarea"
      />
    </div>

    <div className="project-brief-card__upload-section">
      <div className="new-account__content-element project-brief-card--files">
        <div className="new-account__content-input-label form-label">
          Attached Files
        </div>
        <div className="project-brief-card__content project-brief-card__content--attachments">
          {projectAttachments.map((attachment, index) => (
            <div
              key={attachment.url}
              className="project-brief-card__attachment-element"
            >
              <div className="project-brief-card__attachment-name">
                {index + 1} - <a href={attachment.url}>{attachment.name}</a>
              </div>
              <div className="project-brief-card__attachment-remove">
                <span
                  className="project-brief-card__attachment-remove--icon"
                  onClick={event =>
                    handleRemoveUpload(event, attachment, 'attachment')
                  }
                />
              </div>
            </div>
          ))}

          {isUploadingAttachment && (
            <div className="project-brief-card__attachment-element">
              <div className="project-brief-card__attachment-name project-brief-card__attachment-name-loader">
                {projectAttachments.length + 1} - Uploading File...
              </div>
            </div>
          )}
        </div>

        <label htmlFor="attachment" className="project-brief-card__uploader">
          <input
            id="attachment"
            name="profileAttachment"
            type="file"
            onChange={event => handleProjectUpload(event, 'attachment')}
          />
          <span className="project-brief-card__uploader--icon" />
          Upload an attachment
        </label>
      </div>
      {projectPicture && (
        <div className="new-account__content-element project-brief-card--image">
          <div className="new-account__content-input-label form-label">
            <a
              onClick={event =>
                handleRemoveUpload(event, projectPicture, 'project_picture')
              }
              className="new-account__content-input-label-remove-link"
            >
              Remove Project Image
            </a>
          </div>
          <div className="project-brief-card__content project-brief-card__content--picture">
            <img
              alt="project"
              src={projectPicture}
              className="project-brief-card__content--picture-cover"
            />
          </div>
        </div>
      )}
      {!projectPicture && (
        <div className="new-account__content-element project-brief-card--image">
          <div className="new-account__content-input-label form-label">
            Set Project Image
          </div>
          <div className="project-brief-card__content project-brief-card__content--picture">
            <label
              className="project-brief-card__uploader-picture"
              htmlFor="picture"
            >
              <input
                id="picture"
                type="file"
                name="profilePicture"
                accept="image/*"
                onChange={event =>
                  handleProjectUpload(event, 'project_picture')
                }
              />
              {!isUploadingProjectPicture && (
                <span className="project-brief-card__uploader-picture--icon" />
              )}

              {isUploadingProjectPicture && (
                <div className="project-brief-loader">
                  <img src={loader} alt="Project Loader" />
                </div>
              )}
            </label>
          </div>
        </div>
      )}
    </div>
  </div>
);

ProjectBrief.propTypes = {
  projectName: PropTypes.string,
  projectBrief: PropTypes.string,
  projectPicture: PropTypes.string,
  projectAttachments: PropTypes.array,
  handleProjectBriefInput: PropTypes.func,
  handleProjectUpload: PropTypes.func,
  handleRemoveUpload: PropTypes.func,
  isUploadingAttachment: PropTypes.bool,
  isUploadingProjectPicture: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/ProjectBrief/ProjectBrief.js